<div class="details-button-wrapper" (click)="expandCollapseBtnClicked()">
  <a class="toggle-link">
    <i class="material-symbols-outlined">{{ expandCollapseButtonIcon }}</i> {{ expandCollapseButtonText }}
  </a>
</div>
